export class HhsgSharedHuronContract {
	id: number;
	clientId: number;
	name: string;
	number: string;
	notes: string;
	isEditing: boolean;
	isNew: boolean;
}
